import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";

import InputLabel from "@mui/material/InputLabel";
import Button from "@mui/material/Button";
import Paper from "@mui/material/Paper";
import CssBaseline from "@mui/material/CssBaseline";
import * as userApi from "../../api/userApi";
import * as companyApi from "../../api/companyApi";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import SaveIcon from "@mui/icons-material/Save";
import { toast } from "react-toastify";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { connect } from "react-redux";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import HelpOutlineIcon from "@mui/icons-material/HelpOutline";

class ProfilePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      profile: {},
      companies: [],
      errors: {},
      message: "",
    };
  }

  async componentDidMount() {
    try {
      const userName = this.props.signedin
        ? this.props.signedin.userName
        : sessionStorage.getItem("token")
          ? JSON.parse(sessionStorage.getItem("token")).userName
          : "";

      if (userName) {
        const profile = await userApi.getUser(userName);
        if (profile) {
          this.setState({ profile: profile[0] });
        }
      }
      this.getCompanies();
    } catch (error) {
      console.log("Error in componentDidMount", error);
    }
  }

  getCompanies = async () => {
    const companies = await companyApi.getCompanies();
    if (companies) {
      companies.sort((a, b) => {
        if (a.companyName < b.companyName) return -1;
        if (a.companyName > b.companyName) return 1;
        return 0;
      });
      this.setState({ companies });
    }
  };

  onChange = (e) => {
    try {
      const name = e.target.name;
      const value = e.target.value;
      const errors = { ...this.state.errors };
      errors[name] = "";
      this.setState({ errors });

      const profile = { ...this.state.profile };
      profile[name] = value;
      this.setState({ profile });
    } catch (error) {
      console.log("Error in onChange", error);
    }
  };

  handleRadioButtonChange = () => {
    try {
      const profile = { ...this.state.profile };
      profile.activeUser = !profile.activeUser;
      this.setState({ profile });
    } catch (error) {
      console.log("Error in handleRadioButtonChange", error);
    }
  };

  handleCheckboxChange = (e) => {
    try {
      const profile = { ...this.state.profile };
      profile[e.target.name] = e.target.value === "0" ? 1 : 0;
      this.setState({ profile });
    } catch (error) {
      console.log("Error in handleCheckboxChange", error);
    }
  };

  onSave = async (event) => {
    try {
      event.preventDefault();
      if (!this.formIsValid()) return;
      let status = "";
      if (this.state.profile.admin === 1 || this.state.profile.fno === 1) {
        status = await userApi.updateUserAdimn(this.state.profile);
        if (status === "Does not meet Admin requierments for passwords.") {
          const errors = {};
          errors.newPassword =
            "Passordet må være minst 10 tegn (16 tegn for Admin). Må innholde minst én liten bokstav, én stor bokstav, ett tall og ett spesialtegn.";
          this.setState({ errors });
          return;
        }
        if (status === "Password previously used.") {
          const errors = {};
          errors.newPassword =
            "Passordet må ikke være samme som de 13 forrige. Velg et nytt passord";
          this.setState({ errors });
          return;
        }
      } else {
        status = await userApi.updateUser(this.state.profile);
        if (status === "Does not meet requierments for passwords.") {
          const errors = {};
          errors.newPassword =
            "Passordet må være minst 10 tegn. Må innholde minst én liten bokstav, én stor bokstav, ett tall og ett spesialtegn.";
          this.setState({ errors });
          return;
        }
        if (status === "Password previously used.") {
          const errors = {};
          errors.newPassword =
            "Passordet må ikke være samme som de 13 forrige. Velg et nytt passord";
          this.setState({ errors });
          return;
        }
      }
      if (status) {
        toast.success("Profile lagret.");
      } else {
        toast.error("Det skjedd noe feil...");
      }
    } catch (error) {
      throw error;
    }
  };

  formIsValid = () => {
    const { newPassword, repeatPassword } = this.state.profile;
    const errors = {};
    if (newPassword && !repeatPassword) {
      errors.repeatPassword = "Gjentatt passord er påkrevd.";
    } else if (repeatPassword && !newPassword) {
      errors.newPassword = "Nytt passord er påkrevd.";
    } else if (newPassword !== repeatPassword) {
      errors.repeatPassword = "Passord og gjenta passord må være like.";
    }
    this.setState({ errors });
    return Object.keys(errors).length === 0;
  };

  handleClick = async () => {
    const response = await userApi.setUpMfa();
    if (response) {
      let path = response.qrCodeSetupImageUrl;
      //window.location.assign(path);
      //window.open(path, "_blank");
      debugBase64(path);
    }
    function debugBase64(base64URL) {
      var win = window.open();
      win.document.write('<iframe src="' + base64URL + '" frameborder="0" style="border:0; top:0px; left:0px; bottom:0px; right:0px; width:100%; height:100%;" allowfullscreen></iframe>');
    }
  };

  render() {
    const layout = { width: "100%", paddingTop: 80 };
    const paper = { paddingLeft: 30, paddingTop: 20, paddingBottom: 30 };
    const icon = {
      //color: "#3f51b5",
      fontSize: "0.9rem",
    };

    const disable = this.state.profile.fno === 0 && this.state.profile.admin === 0;

    return (
      <Container maxWidth="lg">
        <form onSubmit={this.onSave}>
          <main style={layout}>
            <Paper style={paper}>
              <CssBaseline />
              <h1>Min profil</h1>
              {disable ? null : (
                <Grid>
                  <Button color="primary" onClick={this.handleClick}>
                    Klikk her for å aktivere Google Authenticator kode
                  </Button>
                  <Tooltip
                    title={
                      <span style={{ fontSize: 16 }}>
                        1. Last ned "Google Authenticator" i
                        AppStore/GooglePlay
                        <br />
                        <br />
                        2.Trykk "START KONFIGURERINGEN" og deretter "Skann en
                        QR-kode" <br />
                        <br />
                        3. Skann QR-koden med Google Authenticator
                        applikasjonen på din mobiltelefon og verifiser at en
                        6-sifret kode dukker opp i app'en <br />
                        <br />
                        4. 2FA med Google Authenticator er nå aktivert på
                        nettsiden og satt opp på mobiltelefonen. Ved neste
                        innlogging MÅ 2FA-koden fra Google Authenticator
                        oppgis sammen med brukernavn og passord
                      </span>
                    }
                    placement="bottom-end"
                  >
                    <IconButton aria-label="info">
                      <HelpOutlineIcon style={icon} />
                    </IconButton>
                  </Tooltip>
                </Grid>
              )}
              <Grid container spacing={3}>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <TextField
                    name="userName"
                    label="Brukernavn"
                    value={this.state.profile.userName || ""}
                    fullWidth
                    required
                    disabled
                    variant="standard"
                    sx={{ mb: 2 }}
                  />
                  <FormControl required fullWidth variant="standard" sx={{ mb: 2 }}>
                    <InputLabel>Bedrift</InputLabel>
                    <Select
                      name="companyId"
                      value={this.state.profile.companyId || ""}
                      onChange={this.onChange}
                      disabled={disable}
                    >
                      {this.state.companies.map((company) => (
                        <MenuItem key={company.companyId} value={company.companyId}>
                          {company.companyName}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <TextField
                    name="fullName"
                    label="Navn"
                    value={this.state.profile.fullName || ""}
                    onChange={this.onChange}
                    fullWidth
                    variant="standard"
                    required
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    name="userEmail"
                    label="E-post"
                    value={this.state.profile.userEmail || ""}
                    fullWidth
                    disabled
                    variant="standard"
                    required
                    sx={{ mb: 4 }}
                  />
                  <h3>Endre passord</h3>
                  <TextField
                    name="oldPassword"
                    label="Gammelt passord"
                    type="password"
                    value={this.state.profile.oldPassword || ""}
                    onChange={this.onChange}
                    fullWidth
                    variant="standard"
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    name="newPassword"
                    label="Nytt passord"
                    type="password"
                    value={this.state.profile.newPassword || ""}
                    onChange={this.onChange}
                    fullWidth
                    variant="standard"
                    error={Boolean(this.state.errors.newPassword)}
                    helpertext={this.state.errors.newPassword || ""}
                    sx={{ mb: 2 }}
                  />
                  <TextField
                    name="repeatPassword"
                    label="Gjenta nytt passord"
                    type="password"
                    value={this.state.profile.repeatPassword || ""}
                    onChange={this.onChange}
                    fullWidth
                    variant="standard"
                    error={Boolean(this.state.errors.repeatPassword)}
                    helpertext={this.state.errors.repeatPassword || ""}
                    sx={{ mb: 2 }}
                  />
                  <Button
                    startIcon={<SaveIcon />}
                    type="submit"
                    variant="contained"
                    color="primary"
                  >
                    Lagre
                  </Button>
                </Grid>
                <Grid item lg={6} md={6} sm={12} xs={12}>
                  <h4>Tilganger</h4>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="admin"
                        value={this.state.profile.admin}
                        checked={Boolean(this.state.profile.admin)}
                        onChange={this.handleCheckboxChange}
                        color="primary"
                        disabled={disable}
                      />
                    }
                    label="Admin"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="fno"
                        value={this.state.profile.fno}
                        checked={Boolean(this.state.profile.fno)}
                        onChange={this.handleCheckboxChange}
                        color="primary"
                        disabled={disable}
                      />
                    }
                    label="FNO"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="tff"
                        value={this.state.profile.tff}
                        checked={Boolean(this.state.profile.tff)}
                        onChange={this.handleCheckboxChange}
                        color="primary"
                        disabled={disable}
                      />
                    }
                    label="TFF"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="yff"
                        value={this.state.profile.yff}
                        checked={Boolean(this.state.profile.yff)}
                        onChange={this.handleCheckboxChange}
                        color="primary"
                        disabled={disable}
                      />
                    }
                    label="YFF"
                  />
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="gk"
                        value={this.state.profile.gk}
                        checked={Boolean(this.state.profile.gk)}
                        onChange={this.handleCheckboxChange}
                        color="primary"
                        disabled={disable}
                      />
                    }
                    label="GK"
                  />
                  <h4>Status</h4>
                  <RadioGroup row>
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      checked={this.state.profile.activeUser === true}
                      onChange={this.handleRadioButtonChange}
                      label="Aktiv"
                      disabled={disable}
                    />
                    <FormControlLabel
                      control={<Radio color="primary" />}
                      checked={this.state.profile.activeUser === false}
                      onChange={this.handleRadioButtonChange}
                      label="Inaktiv"
                      disabled={disable}
                    />
                  </RadioGroup>
                </Grid>
              </Grid>
            </Paper>
          </main>
        </form>
      </Container>
    );
  }
}





function mapStateToProps(state) {
  const signedin = state.signedinuserobject
    ? state.signedinuserobject.signedInUser
    : "";

  return { signedin };
}

export default connect(mapStateToProps)(ProfilePage);
